import { render } from "./DownloadView.vue?vue&type=template&id=77b0939a"
import script from "./DownloadView.vue?vue&type=script&lang=js"
export * from "./DownloadView.vue?vue&type=script&lang=js"

import exportComponent from "/home/teo/git_repos/cancer-classifier-app/cancer-classifier-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__